export default {
  NEW_EMAIL: 'New email',
  NO_CONTACTS_ADDED: 'No contacts added',
  UPLOAD_ERROR: 'Unable to upload.',
  SEND_ERROR: 'Unable to send email',
  SEARCH_CONTACT_ERROR: 'Error when searching for contacts: {error}',
  MORE: 'More',
  FILTER: 'Filter',
  FILE: 'File',
  SPAM: 'Spam',
  NOT_SPAM: 'It is not spam',
  DELETE: 'Delete',
  MARK_AS_READ: 'Mark as read',
  MARK_AS_UNREAD: 'Mark as Unread',
  SEARCH: 'Search',
  FOR: 'For',
  SEARCH_EMAIL: 'Search email',
  TO_FILE: 'To file',
  UNARCHIVE: 'Unarchivo',
  PERMANENTLY_DELETE: 'Permanently delete',
  TO_RECOVER: 'To recover',
  EMAIL_DOES_NOT_EXIST: 'Email does not exist',
};
